export const stores = state => state.stores
export const store = state => state.store
